import { createApp } from 'vue'
import merge from './merge'
import VerticalCenterModal from '@/components/VerticalCenterModal.vue'

const defaultOption = {
  title: '提示',
  message: '',
  cancelButtonText: '取消',
  confirmButtonText: '確認',
  showCancelButton: true,
  cancelBtnColor: 'secondary',
  confirmBtnColor: 'primary',
}

let instance = null
const message = (option) => {
  const _option = merge({}, defaultOption, option)
  if (!instance) {
    const container = document.createElement('div')
    instance = createApp(VerticalCenterModal).mount(container)
    document.body.appendChild(container)
  }

  for (let key in _option) {
    instance[key] = _option[key]
  }

  instance.visible = true
}

export default message
